import { StudioFinderSearchfield } from './StudioFinderSearchfield'

export default StudioFinderSearchfield
